export default __webpack_public_path__ + "images/SVO.a75b6c8.png";